// Phase 7 (scenaria-english-support): accept the fr|en scene-header token union
// ("Scène" | "Scene", French "n°" | English "no."/"#" | omitted) so stored
// French conversations and future English emission both parse. Emission stays
// French for now — widen the parser, never narrow it (plan D4 / L1).
const SCENE_HEADER_REGEX = /^###\s+Sc[eè]ne\s+(?:n°|no\.?|#)?\s*\d+:\s*(.*)/;

const parseMarkdown = (markdown: string) => {
  const lines = markdown.split("\n");
  const scenes: { title: string; media: string; interactions: string[] }[] = [];

  let currentScene: any = null;

  for (const line of lines) {
    // Only recognise scene headers in the strict format "### Scène n° X: ..."
    // Everything outside a recognised scene block is ignored, so extra LLM
    // content (notes, recommendations, etc.) never pollutes the graph — whether
    // or not the LLM separates it with --- / -- / horizontal rules.
    const sceneMatch = line.match(SCENE_HEADER_REGEX);
    if (sceneMatch) {
      if (currentScene) {
        scenes.push(currentScene);
      }
      currentScene = { title: sceneMatch[1].trim(), media: "", interactions: [] };
      continue;
    }

    // Nothing to collect outside a scene block
    if (!currentScene) continue;

    // Accept both the French ("#### Média:") and English ("#### Media:") media
    // token. NOTE the divergence with the backend parser
    // (apps/backend-strapi/src/api/gpt-conversation/utils/parseMarkdown.js),
    // which matches a bare "Média:" with no leading "####" — that mismatch
    // between the two render↔parse pairs pre-dates this feature and is left
    // untouched here (plan L1: separate contracts, out of scope to unify).
    if (line.startsWith("#### Média:") || line.startsWith("#### Media:")) {
      currentScene.media = line.replace(/^#### M[ée]dia:\s?/, "");
    } else if (line.startsWith("- ")) {
      // Check if interaction is in bold or not
      const boldMatch = line.match(/\*\*(.*?)\*\*/);
      const regularMatch = line.match(/- (.*?):/);

      if (boldMatch) {
        currentScene.interactions.push(boldMatch[1].trim());
      } else if (regularMatch) {
        currentScene.interactions.push(regularMatch[1].trim());
      }
    }
  }

  if (currentScene) {
    scenes.push(currentScene);
  }

  return scenes;
};

export default parseMarkdown;
